import { BarePhoneVerificationComponent } from "modals/PhoneNumberModal/PhonePopup"

// Rendered inside Onboarding's shared AuthLayout.
const Whatsapp = () => <BarePhoneVerificationComponent />

export default Whatsapp
